export default "__VITE_ASSET__ac6e1425__"